export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-7a-7c06d770e19fc36506db92df74e5de45.webp";